import { useEffect, useState } from 'react';

const useMediaQuery = (query = '') => {
  const matchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query)
      : null;
  const [matches, setMatches] = useState(matchMedia?.matches ?? false);

  useEffect(() => {
    const handleChange = () => setMatches(matchMedia?.matches ?? false);

    if (matchMedia) {
      if (matchMedia.addEventListener) {
        matchMedia.addEventListener('change', handleChange);
      } else if (matchMedia.addListener) {
        matchMedia.addListener(handleChange);
      } else {
        console.error(`useMediaQuery: no add listener found ${JSON.stringify(matchMedia)}`);
      }
    }
    return () => {
      if (matchMedia)
        if (matchMedia.removeEventListener) {
          matchMedia.removeEventListener('change', handleChange);
        } else if (matchMedia.removeListener) {
          matchMedia.removeListener(handleChange);
        } else {
          console.error(`useMediaQuery: no remove listener found ${JSON.stringify(matchMedia)}`);
        }
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
